/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMeetingCommand } from '../../models/delete-meeting-command';
import { DeleteMeetingCommandResult } from '../../models/delete-meeting-command-result';

export interface ApiMeetingsDeleteMeetingDelete$Params {
      body?: DeleteMeetingCommand
}

export function apiMeetingsDeleteMeetingDelete(http: HttpClient, rootUrl: string, params?: ApiMeetingsDeleteMeetingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMeetingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsDeleteMeetingDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteMeetingCommandResult>;
    })
  );
}

apiMeetingsDeleteMeetingDelete.PATH = '/api/Meetings/DeleteMeeting';
